import axios from 'axios'
import $http from '@/libs/axios'

let cancelTokenSource: any = null

export default class PageApi {
  static async postsList(pageId?: string) {
    const page = pageId ?? ''
    return (await $http.get(`pages/posts/${page}`)).data
  }

  static async checkPost(pageId: number, data: { post_id?: string; post_url?: string }) {
    return (await $http.post(`pages/check-post/${pageId}`, data)).data
  }

  static async blockPage(pageId?: number) {
    return (await $http.get(`admin/pages/ban-page/${pageId}`)).data
  }

  static async addPermissions(pageId?: number) {
    return (await $http.get(`admin/pages/add-permissions/${pageId}`)).data
  }

  static async checkPermissions(pageId?: number) {
    return (await $http.get(`admin/pages/check-permissions/${pageId}`)).data
  }

  static async stopComments(pageId?: number) {
    return (await $http.get(`admin/pages/stop-comments/${pageId}`)).data
  }

  static async stopReplies(pageId?: number) {
    return (await $http.get(`admin/pages/stop-replies/${pageId}`)).data
  }

  static async addMenu(pageId?: number) {
    return (await $http.get(`admin/pages/add-menu/${pageId}`)).data
  }

  static async deleteMenu(pageId?: number) {
    return (await $http.get(`admin/pages/delete-menu/${pageId}`)).data
  }

  static async deletePage(pageId: number) {
    return (await $http.delete(`admin/pages/delete/${pageId}`)).data
  }

  static async deletePageByOwner(pageId: number) {
    return (await $http.delete(`pages/${pageId}`)).data
  }

  static async checkTokens() {
    return (await $http.get('pages/token-status')).data
  }

  static async renewPage(pageId: number) {
    return (await $http.get(`admin/pages/renew/${pageId}`)).data
  }

  static async updatePage(pageId: number, data: any) {
    return (await $http.post(`admin/pages/update/${pageId}`, data)).data
  }

  static async suggestions(query: string) {
    if (cancelTokenSource !== null) {
      cancelTokenSource.cancel()
    }
    cancelTokenSource = axios.CancelToken.source()
    const users = (await $http.get(`/admin/pages?search=${query}&limit=30`, { cancelToken: cancelTokenSource.token })).data
    cancelTokenSource = null
    return Array.isArray(users) ? users : []
  }

  static async togglePageCommenter(pageId: number) {
    return (await $http.get(`pages/page-commenter/${pageId}`)).data
  }

  static async getPageFeatures() {
    return (await $http.get('admin/pages/features')).data
  }

  static async updatePageFeatures(pageId: number, data: any) {
    return (await $http.post(`admin/pages/update-features/${pageId}`, data)).data
  }

  static async deleteErrorPage(pageId: number) {
    return (await $http.delete(`admin/pages/error-page/${pageId}`)).data
  }
}
